module.exports = __webpack_public_path__ + "static/media/qrcodemobile.9399e23a.jpg";